/* en */
module.exports = {
    obj: {
        "broswer1": "The browser you are using will cause our platform to load slowly. We recommend using Google Chrome to access the competition.Click here to download Google Chrome.",
        "broswer2": "Win32Bit ",
        "broswer3": "Win64Bit ",
        "broswer4": "Mac",
        "title99": "For more information, please contact info@icode.org",
        "nav_language": "Switch Language",
        "signup_button": "Sign Up",
        "homepage_button1": "Sign In",
        "homepage_button2": "Sign Up",
        "signup_title": "Create An Account",
        "signin_title": "Sign In",
        "myaccount_button": "Save",
        "signup_email4": "Don’t see the email in your inbox? The message might be in your Spam or Junk Mail folders so be sure to check there.\n\nIf you do not receive a verification email within one hour, please try the sign-up process again.",
        "signup_email2": "Please check your email inbox for an email with a link to verify and activate your account.",
        "signup_email3": "Back to Sign In Page",
        "signup_email1": "You’re almost done!",
        "signin_note3": "Please enter your password",
        "signin_note2": "This email address is invalid",
        "signin_note1": "Please enter your email",
        "signin_note5": "This email address is unregistered",
        "signin_note4": "Incorrect password",
        "forPass_title": "Forgot Your Password?",
        "failWin_txt2": "It looks like QiQi ran out of energy. Please try again.",
        "signup_fail1": "/",
        "unit8_name": "Green Spaceship Expeditions",
        "signup_fail2": "This email has already been registered",
        "competition_button": "Start challenge",
        "failWin_txt1": "It looks like there is a problem with part of your code. Hint: It's related to QiQi's steps (number and/or direction). Please try again.",
        "failWin_txt3": "It looks like QiQi ran out of energy. Make sure to avoid the red energy boosts as they will deplete all of QiQi's energy! Please try again.",
        "unit3_name": "Hoverboard Adventures",
        "sucPass_title": "Your Password Was Reset Successfully!",
        "bindaccountMsg":"The account has been bound with other phone.",
        "bindaccountMsgs":"Account Expired",
        "bindaccountWarn":"Active the account with your phone",
        "bindaccountWarn1":"Binding failed, the phone has been bound with other account.",
        "signup_note5": "Verification code error",
        "signup_note4": "/",
        "signup_note7": "Please enter your last name",
        "signup_note6": "This email address is invalid",
        "signup_note1": "This school code is invalid",
        "signup_note3": "Passwords must be identical",
        "signup_note2": "Passwords must be 8-16 characters, using only letters and numerals",
        "signup_note9": "Please choose...",
        "signup_note8": "Please enter your first name",
        "forPass_txt1": "Verify your email to re-set your password",
        "forPass_txt3": "Verify",
        "forPass_txt2": "Email",
        "verifySuc_button": "Enter the Competition",
        "signin_button": "Sign In",
        "unit7_name": "Challenging Terrain",
        "verifyFail_txt": "It looks like you already completed the email verification process.\n\nQuestions? Email info@icode.org",
        "signup_txt8": "Please enter your password again",
        "signup_txt9": "Phone",
        "unit9_name": "Let's Get Energized",
        "signup_txt1": "Last Name",
        "signup_txt2": "First Name",
        "signup_txt3": "Grade",
        "signup_txt4": "School code",
        "signup_txt5": "Enter the school code you received from your teacher",
        "signup_txt6": "Password",
        "signup_txt7": "Passwords must be 8-16 characters, using only letters and numerals",
        "failWin_txt": "It looks like there was a problem with part of your code. Please try again.",
        "verifyFail_title": "Oops!",
        "verifyWrongemail_txt": "It looks like your verification link is incorrect.\nIf you are unable to click the link in your email, please make sure to copy and paste the link correctly into your web browser.\n\nQuestions? Email info@icode.org",
        "unit6_name": "Divide and Conquer",
        "failWin_title": "Oops!",
        "unit5_name": "Finding Your Path",
        "competition_note": "The competition will begin on May 1st! Interested in learning to code? Check out our resources page: \n\n\n\n\n\n\n\n<a target='view_window' href='https://www.icode.org/resources'>https://www.icode.org/resources</a>",
        "signup_txt12": "Phone",
        "signup_txt13": "Please enter your account",
        "signup_txt10": "Verification code",
        "signup_txt11": "Send",
        "myaccount_txt1": "First Name",
        "myaccount_txt2": "Last Name",
        "myaccount_txt3": "Grade",
        "signin_txt4": "Sign Up",
        "signin_txt2": "Set password",
        "signin_txt3": "Forgot Your Password?",
        "signin_txt1": "Phone",
        "signin_txt11": "Account/Phone",
        "sucWin_title": "Well done!",
        "competition_title": "Competition Leader Board",
        "unit2_name": "Spaceship Exploration",
        "homepage_title": "Join the Coding Olympics",
        "setPass_title": "Re-set Password",
        "resetWin_title": "Reset",
        "myaccount_title": "My Account",
        "emailVerify_txt2": "Questions? Email info@icode.org",
        "emailVerify_txt1": "It looks like your verification link is no longer valid. Click here to receive a new verification email.\nRe-send Verification Email",
        "language_switch5": "Arabic",
        "language_switch4": "Hebrew",
        "language_switch3": "Spanish",
        "language_switch2": "English",
        "language_switch1": "Chinese",
        "signup_note15": "Please enter verification code",
        "signup_note14": "Please enter your account",
        "signup_note17": "Please fill in all required information",
        "signup_note16": "Please enter your account",
        "signup_note11": "Enter the school code you received from your teacher",
        "signup_note10": "Please choose your grade",
        "signup_note13": "Please enter your password again",
        "signup_note12": "Please enter your password",
        "resetWin_txt": "Are you sure you would like to reset the coding area? Any code you edited or added will be deleted.",
        "emailVerify_title": "Oops!",
        "forPass_win": "Please check your inbox for a link to reset your password",
        "nav_setting": "Settings",
        "setPass_txt2": "Passwords must be 8-16 characters, using only letters and numerals",
        "setPass_txt3": "Please enter your password again",
        "setPass_txt1": "Password",
        "setPass_txt4": "Submit",
        "nav_name": "Coding Olympics",
        "emailVerify_button": "Re-send Verification Email",
        "emailVerify_note": "Verification Email Has Been Resent Successfully",
        "competition_txt1": "Rank",
        "competition_txt2": "School",
        "competition_txt22": "Student",
        "verifyWrongemail_title": "Oops!",
        "competition_txt4": "Levels",
        "competition_txt44": "My Stars",
        "competition_txt5": "School Score",
        "competition_txt6": "School Ranking",
        "verifyWrong_title": "Oops!",
        "unit4_name": "The Power of Loops",
        "competition_txt3": "Points",
        "forPass_note2": "This email address is invalid",
        "forPass_note3": "Please enter your password",
        "forPass_note1": "Please enter your email",
        "forPass_note6": "Please enter your password",
        "forPass_note7": "This email address is unregistered",
        "forPass_note4": "Please enter your password again",
        "forPass_note5": "Passwords must be identical",
        "sucWin_txt": "Congratulations! You just completed the challenge.",
        "setting_1": "My Account",
        "setting_2": "Log Out",
        "verifyWrong_txt": "It looks like your verification link is incorrect.\nIf you are unable to click the link in your email, please make sure to copy and paste the link correctly into your web browser.\n\nQuestions? Email info@icode.org",
        "verifySuc_txt1": "Your account setup is complete and you’re ready to join the competition.",
        "sucPass_button": "Back to Homepage",
        "myaccount_txt4": "School",
        "verifySuc_title": "Awesome!",
        "myaccount_txt5": "Email",
        "signup_win2": "Please make sure you have your school code and accss to your email inbox in order to complete the account setup process. Don't have a school code? Have your teacher contact us at info@icode.org",
        "signup_win1": "Before We Get Started...",
        "unit10_name": "Taking Control",
        "unit1_name": "First Steps on Mars",
        "bad_network": "No Internet Connection",
        "competition_txt7": "Top points",
        "competition_txt8": 'Country',
        "grade1": 'Grade 1',
        "grade2": 'Grade 2',
        "grade3": 'Grade 3',
        "grade4": 'Grade 4',
        "grade5": 'Grade 5',
        "grade6": 'Grade 6',
        "grade7": 'Grade 7',
        "grade8": 'Grade 8',
        "grade9": 'Grade 9',
        "grade10": 'Grade 10',
        "grade11": 'Grade 11',
        "grade12": 'Grade 12',
        "competition_nav": 'Hi',
        "timeout01": 'Login expired',
        "timeout02": 'Session timeout, please login again',
        "timeout03": 'Re login',
        "timeout04": 'cancel',
        "schoolName": 'School Name',
        "signin_note50": "The competition will officially start on February 15, 2020. Please stay tuned!",
        "myaccountUpdata_title": "Modify information",
        "myaccountUpdata_title01": "Welcome to The Second ICode International Youth Coding Competition Preliminary In order to provide you with a better experience, please confirm whether your account information needs to be updated. Once confirmed, it can't be modified again. If you have any questions, you can consult the teacher of ICode: 13162336268",
        "badMsg": "Basic user information is valid and cannot be updated again.",
        "errmsg": "The competition will officially start on February 15th, 2020. Please stay tuned!",
        "score1": "Student Score",
        "score2": "School Score",
        "score3": "Global",
        "score4": "School",
        "levelProgress1": "Junior",
        "levelProgress2": "Senior",
        "levelProgress3": "Intermediate",
        "version": "My Version",
        "begin": "Beginner",
        "modeCode": "Code",
        "modeScratch": "Blockly",
        "allStars": "Total number of stars",
        "allSteps": "Reduced number of moves",
        "allLines": "Reduced lines of code",
        "bad_errorMsg1": "You can only change to a certified school.",
        "bad_errorMsg2": "You've joined a certified school, can't modify it.",
        "levelProgressAll": 'Total score',
        "levelProgressToday": "Best of today",
        "notice_lang1": "A new revision of the learning platform!<br/>You have become an astronaut, you can use code to help Dev go through space. Start your programming journey from earth to the deep space now!",
        "notice_lang2": "The new semester has begun, while you are busy studying, remember to come and play with Dev often! If you have any good ideas and suggestions, be sure to let us know: info@icode.org.cn",
        "notice_lang3": "If you want to get more learning content, you can become a qualify astronaut and get extra practice levels and monthly competitions(must pass the previous monthly competition).",
        "notice_lang4": "The monthly competition on Earth has been upgraded to a weekly  competition! You can participate in it at any time. If you get 60 stars in 90 minutes, you will be upgraded to Mars.",
        "notice_lang5": "<span style='color:#ffec44'>Random map:</span> In new challenge levels, challengers may unlook different maps! </br><span style='color:#ffec44'>「Best of today」chart:</span> The chart shows the rank based on the daliy score each school wins!",
        "myCompetitions": "My Competitions",
        "competitionName": "Competition name",
        "competitionProgress": "Competition progress",
        "notStart": "Not start",
        "ongoing": "Ongoing",
        "gameover": "Over",
        "registrationReview": "Registration is under review",
        "registrationFailed": "Registration failed",
        "registrationSpproved": "Registration approved",
        "notParticipated": "Not participated",
        "participated": "Participated",
        "myAwards": "My Prize",
        "remarks": "Remarks",
        "downloadCard": "Download Admission card",
        "download": "Other information",
        "noData": "No competition data",
        "registrateFinal": "Registrate for final",
        "myProgress": "My progress",
        "myHome": "My home page",
        "divisions": "Group",
        "stepTips": 'The monthly competition will start on June 28',
        "index_txt49_noOpen":"This competition is only available for qualify astronauts.",
        'finalsTxt':"You can't enter during periods that are not competition time",
        "finalsTxt_noOpen":"You cannot join the competition because you are not a finalist",
        "myStars": "Stars",
        "MyScore": "My Score",
        "Leaderboard": "Leaderboard",
        'langTitle': "Congratulations!When you successfully login into the platform, you will become a trainee astronaut in the ICODE programming universe!As a trainee astronaut, you can use all the basic training courses and join the Earth Competition. We hope you have fun with coding! <br/>By sponsoring us, you can be a qualified astronaut. That means you can unlock more training courses and competitions ! ",
        'langTitle1': "Your sponsorship helps us provide more learning content, thank you!",
        'pay_txt1': 'Become a qualify astronaut',
        'pay_txt2': 'Sponsor ICode',
        'pay_txt3': 'Scan with WeChat',
        'pay_txt4': '1 month',
        'pay_txt5': '3 months',
        'pay_txt6': '12 months',
        'index_txt1': "To upgrade to the Space License: Mars, you need to pass the monthly competition for Earth.",
        'index_txt2': "To upgrade to the Space License: Jupiter, you need to pass the monthly competition for Mars.",
        'index_txt3': "To upgrade to the Space License: Saturn, you need to pass the monthly competition for Jupiter.",
        'index_txt4': "You already have the most advanced license.",
        'index_txt5': "Space License: Earth",
        'index_txt6': "Space License: Mars",
        'index_txt7': "Space License: Jupiter",
        'index_txt8': "Space License: Saturn",
        'index_txt9': "Trainee astronaut",
        'index_txt10': "Qualify astronaut",
        'index_txt11': "Become a qualify astronaut",
        'index_txt12': "Welcome, qualify astronaut",
        'index_txt13': "Python Planet",
        'index_txt14': "Blockly Planet",
        "index_txt15": "Training course",
        "index_txt16": "Welcome to Training ground: Earth",
        "index_txt17": "Welcome to Training ground: Mars",
        "index_txt18": "Welcome to Training ground: Jupiter",
        "index_txt19": "Welcome to Training ground: Saturn",
        "index_txt20": "Go!",
        "index_txt210": "Next promotion competition: ",
        "index_txt211":"Next competition date: October 31, 2020 19:00-20:30",
        "index_txt212":"Next competition date: November 28, 2020 19:00-20:30",
        "index_txt213":"",
        'index_txt22': "Monthly competition",
        'jsNotice':"The finals will be held in Shanghai from August 8th to 9th. The finalists can join the competition after entering the exam room and connecting to the room's wifi. If you have any questions, please ask the invigilator for help.",
        'jsNoticeDemo':'Start at: August 1, 2020 at 9:30, 14:30 and 19:00.<br/>The simulation finals is only for finalists in China.<br/>The difficulty is not a reference for the finals.<br/>Only for be familiar with the process, no awards.',
        'finals_txt1':'2020 ICode Finals (China)',
        'finals_txt2':'Simulation finals',
        "finals_txt3":'2020 ICode Simulation Finals (China)',
        'index_txt34': 'Space License: Mars required.',
        'index_txt35': 'Space License: Jupiter required.',
        'index_txt36': 'Space License: Saturn required.',
        'index_txt37': 'You need to be a qualify astronaut before starting this training',
        'index_txt38': 'Earth Competition in June 2020 (Python)',
        'index_txt39': 'Earth Competition in June 2020 (Blockly)',
        'index_txt40': 'Earth Competition in July 2020 (Python)',
        'index_txt41': 'Earth Competition in July 2020 (Blockly)',
        'index_txt42': 'Mars Competition in July 2020 (Python)',
        'index_txt43': 'Mars Competition in July 2020 (Blockly)',
        'index_txt44': 'Earth Competition in August 2020 (Python)',
        'index_txt45': 'Earth Competition in August 2020 (Blockly)',
        'index_txt46': 'Mars Competition in August 2020 (Python)',
        'index_txt47': 'Mars Competition in August 2020 (Blockly)',
        'index_txt470': 'Jupiter Competition in August 2020 (Python)',
        'index_txt471': 'Jupiter Competition in August 2020 (Blockly)',
        'index_txt472': 'Earth Competition in September 2020 (Python)',
        'index_txt473': 'Earth Competition in September 2020 (Blockly)',
        'index_txt474': 'Mars Competition in September 2020 (Python)',
        'index_txt475': 'Mars Competition in September 2020 (Blockly)',
        'index_txt476': 'Jupiter Competition in September 2020 (Python)',
        'index_txt477': 'Jupiter Competition in September 2020 (Blockly)',
        'index_txt478': 'Saturn Competition in September 2020 (Python)',
        'index_txt479': 'Saturn Competition in September 2020 (Blockly)',

        'index_txtA1': 'Earth Competition (Blockly)',
        'index_txtA2': 'Earth Competition (Python)',

        'index_txt48': 'Design Map',
        'index_txt49': 'The monthly competition has not yet started',
        'index_txt50': 'The monthly competition will start on the last Saturday night of each month from 19:00 to 20:30.<br/>The first monthly competition will start at 19:00 on June 27, 2020.',
        'index_txt51': "National competition",
        'index_txt52': "Monthly competition",
        'index_txt53': "Earth",
        'index_txt54': "Mars",
        'index_txt55': "Jupiter",
        'index_txt56': "Saturn",

        "star_txt1":'Mode',
        "star_txt2":'Class',
        "star_txt3":'Course',
        "star_txt4":'Levels',
        "star_txt5":'Activate course',
        "star_txt6":'name',
        "star_txt7":'Class Dashboard',
        "star_txt8":'My Class',
        "star_txt9":'Course stars',
        "star_txt10":'Levels',
        'star_txt11':"Your account expired, please verify it with avaiable phone number.",

        'index_course_100120':"Basic(2)",
        'index_course_100130':"Basic(3)",
        'index_course_100140':"Basic(4)",
        'index_course_10010':"Basic(1)",
        'index_course_10012':"Basic(2)",
        'index_course_10013':"Basic(3)",
        'index_course_10014':"Basic(4)",
        'index_course_1001':"Basic(1)",
        'index_course_1002':"Creators'",
        'index_course_1003':"For loop",
        'index_course_1004':"Variable Practice",
        'index_course_1005':"Recursion Intro",
        'index_course_1006':"Practice of if",
        'index_course_1007':"Repeat Practice",
        'index_course_1008':"Variable Practice",
        'index_course_1009':"range()",
        'index_course_1010':"If & Distance",
        'index_course_1011':"Repeat Variables",
        'index_course_1012':"Complex variables",
        'index_course_1013':"if else",
        'index_course_1014':"elif statement",
        'index_course_1015':"Find patterns",
        'index_course_1016':"Find patterns",
        'index_course_1017':"Complex Loop",
        'index_course_1018':"Nested repeat(2)",
        'index_course_1019':"Conditional",
        'index_course_1020':"While statement",
        'index_course_1021':"Green Flyers",
        'index_course_1022':"Function",
        'index_course_1023':"Creators'",
        'index_course_1024':"Nested Recursions",
        'index_course_1025':"Flyers",
        'index_course_1026':"Multi-Recursions",
        'index_course_1027':"Green Energy",
        'index_course_1028':"Solar Panels",
        'index_course_1029':"Solar Panels",
        'index_course_1030':"if else",
        'index_course_1031':"Guidance",
        'index_course_1032':"Basic commands",
        'index_course_1033':"Variables in loop",
        'index_course_1034':"Nested Loops",
        'index_course_1035':"Multiple Variables",
        'index_course_1036':"List of Flyers",
        'index_course_1037':"List of Items",
        'index_course_1038':"Logic operation",
        'index_course_1039':"Flyers' movement",
        'index_course_1040':"Parameter",
        'index_course_1041':"Two recursions",
        'index_course_1042':"Dictionary",
        'index_course_1043':"Multi-parameters",
        'index_course_1044':"Guidance",
        'index_course_1045':"Creators'",
        'index_course_1046':"Basic commands",
        'index_course_1047':"Nested repeat(1)",
        'index_course_1048':"Variables",
        'index_course_1049':"Logic operation",
        'index_course_1050':"Coordinate Intro",
        'index_course_1051':'For loop Basic(1)',
        'index_course_1052':'For loop Basic(2)',
        'index_course_1053':'Repeat(1)',
        'index_course_1054':'Repeat(2)',
        'index_course_1055':'Variable Intro',
        'index_course_1056':'Conditional',
        'index_course_1057':'If block',
        'index_course_1058':'Variable Intro',
        'index_course_1059':'Nested Practice',
        'index_course_1060':'Not open',
        'index_course_1061':'Not open',
        'index_course_1062':'Not open',
        'index_course_1063':'Not open',
        'index_course_1064':'Not open',
        'index_course_1065':'Not open',
        'index_course_1066':'Not open',
        'index_course_1067':'Not open',
        'index_course_1068':'Not open',
        'index_course_1069':'Not open',
        'index_course_1070':'Not open',
        "earth_bulletin":"The monthly competition will start on the last Saturday night of each month from 19:00 to 20:30.<br/>The monthly competition in September will start at 19:00 on September 26, 2020.",
        "mars_bulletin":"The monthly competition will start on the last Saturday night of each month from 19:00 to 20:30 for qualify astronaut.</br/>The monthly competition in September will start at 19:00 on September 26, 2020.",
        "saturn_bulletin":"",
        "jupiter_bulletin":"",
        "race_unannounced":"Unannounced",
        'race_noaward':"No award",
        "gameId_msg_701":"The 2nd ICode Competition Finals (China)",
        "gameId_msg_702":"The 2nd ICode Competition Finals (China)",
        "gameId_msg_703":"The 2nd ICode Competition Finals (China)",
        "gameId_msg_704":"The 2nd ICode Competition Finals (China)",
        "gameId_msg_801":"The 2nd ICode Competition Simulation Finals (China)",
        "gameId_msg_802":"The 2nd ICode Competition Simulation Finals (China)",
        "gameId_msg_803":"The 2nd ICode Competition Simulation Finals (China)",
        "gameId_msg_804":"The 2nd ICode Competition Simulation Finals (China)",
        "gameId_msg_1":"The 1st ICode Competition Global Preliminary",
        "gameId_msg_2":"Olympic programming platform",
        "gameId_msg_3":"Icode Olympic Programming Competition",
        "gameId_msg_4":"The 2nd ICode Competition Preliminary (China)",
        "gameId_msg_5":"The 1st ICode Competition Finals (China)",
        "gameId_msg_6":"ICode learning platform",
        "prizeId_1":"Gold",
        "prizeId_2":"Silver",
        "prizeId_3":"Bronze",
        "prizeId_4":"Participate",
        "prizeId_5":"Best Thinker",
        "prizeId_6":"Best Speecher",
        "prizeId_7":"Most potential",
        "prizeId_8":"Young hacker",
        "prizeId_9":"Creative girl",
        "prizeId_10":"Creative boy",
        "prizeId_11":"Code expert",
        "prizeId_12":"ICode Promoter",
        "prizeId_13":"Whimsy",
        "prizeId_14":"Nice try",
        "prizeId_15":"Well done",
        "prizeId_16":"Participant",
        "prizeId_18":"Promotion",
        "time_finals":"Start in ",
        "time_finals01":"Competition is over",
        "non-finalist":"Non-finalist",
        "no_data_course_txt_0":"You have completed all levels on Blockly Planet",
        "no_data_course_txt_1":"Go to the Python Planet for more challenges",
        "enter_tech_btn":"Enter",
        "ret_coe_txt_49":"Course Not Open",
        "course_explain":"Instruction",
        "invite_title":"Invite Member",
        "week_game_tips":"This week's qualifying tournament is open.",
        "week_game_tips_info":"There is only one chance for promotion once a week.  It should be completed within 90 minutes after the start. Are you sure to start now?",
        "week_game_tips_info_txt":"Are you sure?",
        "game_title_8001":"2020 ICode Week Competition",
        "game_title_8002":"2020 ICode Week Competition",
        "week_game_already_go":"You have already participated in this week's competition",
        "week_enter_txt_btn":"Start Competition",
        "week_warning_btn_start":"OK",
        "week_warning_btn_not_start":"Cancel",
        "share_Phone_txt":"Recommended Phone"
    }
}



// WEBPACK FOOTER //
// ./src/utils/i18n/en.js